
























































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      secretDialog: {
        show: false,
        title: "",
        clientId: "",
        secret: "",
        showSecret: false,
      },
      tableOptions: null as any,
    };
  },
  created() {
    const self = this;
    this.tableOptions = {
        attrs: {
          "item-key": "clientId",
          "sort-by": "name",
          "sort-desc": false,
        },
        content: {
          name: "API Credentials",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              name: {
                attrs: {
                  label: "Name",
                },
                rules: {
                  match: {},
                },
              },
              clientId: {
                attrs: {
                  label: "Client ID",
                },
                rules: {
                  match: {},
                },
              },
            },
          },
          displayFields: {
            name: {
              text: "Name",
              sortable: true,
            },
            clientId: {
              text: "Client ID",
              sortable: true,
              options: {
                label: true,
              },
            },
            description: {
              text: "Description",
              sortable: false,
            },
            isActive: {
              text: "Status",
              options: {
                boolean: true,
                label: (value: boolean) => {
                  return value ? "Active" : "Inactive";
                },
                attrs(value) {
                  return {
                    color: value ? "success" : "error",
                  };
                },
              },
            },
            lastUsedAt: {
              text: "Last Used",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            createdAt: {
              text: "Created At",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {
              text: "Actions",
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin", "admin"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              more: userManager.checkRole(["systemAdmin", "admin"]) && {
                items: [
                  {
                    icon: "mdi-rotate-right",
                    label: "Rotate Secret",
                    action: async (item) => {
                      if (
                        confirm(
                          `Are you sure you want to rotate the secret for "${item.name}"?\n\nThis will invalidate the old secret immediately!`
                        )
                      ) {
                        try {
                          const response = await coreApiClient.call(
                            "apiCredentials",
                            "rotateSecret",
                            { clientId: item.clientId }
                          );
                          console.log("Rotate secret response:", response);
                          self.showSecretDialog(
                            "Secret Rotated Successfully",
                            response.clientId,
                            response.newSecret || response.clientSecret
                          );
                          // Refresh table
                          self.$forceUpdate();
                        } catch (error) {
                          console.error("Failed to rotate secret:", error);
                          alert("Failed to rotate secret. Please try again.");
                        }
                      }
                    },
                  },
                  {
                    icon: "mdi-check-circle",
                    label: "Activate",
                    show: (item) => !item.isActive,
                    action: async (item) => {
                      try {
                        await coreApiClient.call("apiCredentials", "activate", {
                          clientId: item.clientId,
                        });
                        alert(`API credential "${item.name}" has been activated.`);
                        // Refresh table
                        self.$forceUpdate();
                      } catch (error) {
                        console.error("Failed to activate:", error);
                        alert("Failed to activate credential. Please try again.");
                      }
                    },
                  },
                  {
                    icon: "mdi-cancel",
                    label: "Deactivate",
                    show: (item) => item.isActive,
                    action: async (item) => {
                      if (
                        confirm(
                          `Are you sure you want to deactivate "${item.name}"?\n\nThis will prevent the credential from being used for authentication.`
                        )
                      ) {
                        try {
                          await coreApiClient.call("apiCredentials", "deactivate", {
                            clientId: item.clientId,
                          });
                          alert(`API credential "${item.name}" has been deactivated.`);
                          // Refresh table
                          self.$forceUpdate();
                        } catch (error) {
                          console.error("Failed to deactivate:", error);
                          alert("Failed to deactivate credential. Please try again.");
                        }
                      }
                    },
                  },
                ],
              },
              delete: userManager.checkRole(["systemAdmin", "admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call(
                "apiCredentials",
                "findAll",
                options
              );
              return [items, count];
            },
            async insert(item) {
              const response = await coreApiClient.call(
                "apiCredentials",
                "create",
                undefined,
                item
              );
              // Show the secret to the user
              self.showSecretDialog(
                "API Credential Created",
                response.clientId,
                response.clientSecret
              );
              return response;
            },
            async update(item) {
              return await coreApiClient.call(
                "apiCredentials",
                "update",
                {
                  clientId: item.clientId,
                },
                {
                  name: item.name,
                  description: item.description,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("apiCredentials", "delete", {
                clientId: item.clientId,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Name",
                  required: true,
                  hint: "A friendly name for this API credential",
                },
              },
              description: {
                type: "textarea",
                attrs: {
                  label: "Description",
                  rows: 3,
                  hint: "Optional description of what this credential is used for",
                },
              },
            },
            insertForm: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                fieldNames: ["name", "description"],
              },
            },
            editForm: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                fieldNames: ["name", "description"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      };
  },
  methods: {
    showSecretDialog(title: string, clientId: string, secret: string) {
      this.secretDialog = {
        show: true,
        title,
        clientId,
        secret,
        showSecret: false,
      };
    },
    closeSecretDialog() {
      this.secretDialog.show = false;
      // Clear sensitive data
      setTimeout(() => {
        this.secretDialog.clientId = "";
        this.secretDialog.secret = "";
      }, 300);
    },
    copyToClipboard(text: string) {
      navigator.clipboard.writeText(text).then(
        () => {
          alert("Copied to clipboard!");
        },
        (err) => {
          console.error("Failed to copy:", err);
          alert("Failed to copy to clipboard");
        }
      );
    },
  },
});
